import React from 'react';
import cn from 'classnames';

import styles from './Word.module.css';

const Word = ({ children, type, color, delay, animate }) => (
  <span className={cn(styles.wrapper, { [`${styles.animate}`]: animate })}>
    <span className={styles.wrapperAfter} style={{ color, animationDelay: `${delay}ms` }}>
      {type}
    </span>
    <span className={styles.word}>
      <span
        className={styles.wordAfter}
        style={{ background: color, animationDelay: `${delay}ms` }}
      />
      <span className={styles.text}>{children}</span>
    </span>
  </span>
);

export default Word;
